import { useState, useEffect } from 'react'
import { InputModel } from '../../../../../../../utils/types'
import { Item } from '../../../../../../../utils/types/generals'

const useInput = ({ items }: { items?: { [x: string]: Item[] } }) => {
  const [input, setInput] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.search',
      translate: true,
      name: 'search',
      rest: {
        type: 'alphaNumeric',
      },
      value: null,
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
      },
    },
    fileType: {
      label: 'general.tags.fileType',
      translate: true,
      name: 'fileType',
      type: 'filter-select',
      items: [],
      value: [],
      //notAllowedRoles: [Roles.AUDIT],
    },
    percentage: {
      label: 'filesManager.tags.percentage',
      translate: true,
      name: 'percentage',
      type: 'percentageWithLimit',
      value: null,
      ranges: [0,40]
    },
    user: {
      label: 'general.tags.user',
      translate: true,
      name: 'user',
      type: 'filter-select',
      items: [],
      value: [],
      //notAllowedRoles: [Roles.AUDIT],
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    status: {
      label: 'general.tags.status',
      translate: true,
      name: 'status',
      type: 'filter-select',
      items: items?.status ?? [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
  })

  useEffect(() => {
    let body = {}
    Object.entries(input).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } }
    })

    setInput(body)

  }, [items])

  return { input }
}

export { useInput }
